import * as React from "react";

function IconFlask2Off({
  size = 24,
  color = "currentColor",
  stroke = 2,
  ...props
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-flask-2-off" width={size} height={size} viewBox="0 0 24 24" strokeWidth={stroke} stroke={color} fill="none" strokeLinecap="round" strokeLinejoin="round" {...props}><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M6.1 15h8.9" /><path d="M17.742 17.741a6 6 0 0 1 -2.424 3.259h-6.635a6.002 6.002 0 0 1 1.317 -10.66v-.326m0 -4.014v-3h4v7m.613 .598a6.004 6.004 0 0 1 2.801 2.817" /><path d="M9 3h6" /><path d="M3 3l18 18" /></svg>;
}

export default IconFlask2Off;